var map = {
  "./": "47052",
  "./costs": "17737",
  "./costs.js": "17737",
  "./details": "55378",
  "./details.js": "55378",
  "./details_tab": "26746",
  "./details_tab.js": "26746",
  "./edit": "32726",
  "./edit.js": "32726",
  "./index": "47052",
  "./index.js": "47052",
  "./new": "83638",
  "./new.js": "83638",
  "./root_object": "47578",
  "./root_object.js": "47578",
  "./show": "98607",
  "./show.js": "98607",
  "./utilities_costs": "14105",
  "./utilities_costs.js": "14105"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 49976;
